/* Copyright (c) 2021-2026, NVIDIA CORPORATION.  All rights reserved.
*
* NVIDIA CORPORATION and its licensors retain all intellectual property
* and proprietary rights in and to this software, related documentation
* and any modifications thereto.  Any use, reproduction, disclosure or
* distribution of this software and related documentation without an express
* license agreement from NVIDIA CORPORATION is strictly prohibited.
*/

/** This file was automatically generated. DO NOT MODIFY IT BY HAND. */

/* eslint-disable @typescript-eslint/naming-convention */

/** Import exported objects from lower level directories */



/** Import exported objects from current directory files */

import { DriverinstallTypes } from './driverInstall.types';
import { DriverupdaterecommendationTypes } from './driverupdaterecommendation.types';
import { GfnsdkTypes } from './gfnsdk.types';
import { LocalgamesTypes } from './localgames.types';

/** Export current level object and nested objects */

export module GfeTypes {
export import Driverinstall = DriverinstallTypes;
export import Driverupdaterecommendation = DriverupdaterecommendationTypes;
export import Gfnsdk = GfnsdkTypes;
export import Localgames = LocalgamesTypes;
}


